Greenmile.Survey.Sidebar.GenericMultiAnswers = function () {

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);

    this.didRenderTemplate = function (question) {
        var textInput         = document.createElement('textarea'),
            inputContainer    = document.createElement('div'),
            contentHeader     = document.createElement('div'),
            questionContainer = document.querySelector('.questionContent');

        textInput.rows = 4;
        textInput.cols = 50;
        textInput.id = this.textAreaId;
        inputContainer.class = this.bodyClass;
        contentHeader.class = "contentHeader";
        inputContainer.appendChild(contentHeader);
        contentHeader.id = 'Survey_new_answer_many';
        contentHeader.innerHTML = Monet.I18n.getResourcesByKey('Survey.new.answer.many');
        inputContainer.appendChild(textInput);

        questionContainer.appendChild(inputContainer);

        this.addDefaultValueField(question, 'TEXT', textInput);
    };

};
